import { motion } from "framer-motion";
import { Reveal } from "@/components/motion";

const STEPS = [
  { n: "01", title: "Analisi", time: "2 settimane", desc: "Fotografiamo numeri, organizzazione e mercato: marginalità, cassa, ruoli, posizionamento. Sai esattamente dove sei." },
  { n: "02", title: "Priorità", time: "90 giorni", desc: "Scegliamo insieme le tre azioni a maggiore impatto, con obiettivi misurabili e responsabilità assegnate." },
  { n: "03", title: "Esecuzione", time: "in affiancamento", desc: "Lavoriamo con te sull'operatività: finanza, bandi, persone, marketing, processi. Un referente unico coordina tutto." },
  { n: "04", title: "Monitoraggio", time: "ogni mese", desc: "Verifichiamo KPI e scostamenti. Quello che non funziona si cambia: le decisioni restano guidate dai dati." },
];

export const MethodTimeline = () => (
  <section className="py-16 sm:py-32 border-t border-[#141414] overflow-hidden" data-testid="method-timeline">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow mb-5">Il metodo</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white max-w-3xl leading-[1.1]" style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }} data-testid="method-h2">
          Come lavoriamo, <span className="text-[#FACC15]">passo dopo passo</span>
        </h2>
      </Reveal>

      <div className="relative mt-16">
        <div className="absolute left-0 right-0 top-[22px] h-px bg-[#1f1f1f] hidden lg:block" />
        <motion.div
          className="absolute left-0 top-[22px] h-px bg-[#FACC15] hidden lg:block origin-left"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "0px 0px -80px 0px" }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          style={{ width: "100%" }}
          data-testid="method-progress"
        />
        <div className="absolute left-[22px] top-0 bottom-0 w-px bg-[#1f1f1f] lg:hidden" />

        <ol className="grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.2 + i * 0.25} className="relative pl-16 lg:pl-0" as="li">
              <motion.div
                className="absolute left-0 lg:static w-11 h-11 bg-black border border-[#FACC15] text-[#FACC15] flex items-center justify-center font-bold"
                style={{ fontFamily: "'Outfit', sans-serif" }}
                initial={{ scale: 0.6, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 + i * 0.25, duration: 0.5, type: "spring", stiffness: 220 }}
                data-testid={`method-step-${s.n}`}
              >
                {s.n}
              </motion.div>
              <div className="lg:mt-8">
                <p className="text-[#FACC15] text-xs tracking-[0.2em] uppercase">{s.time}</p>
                <h3 className="text-white text-2xl font-bold mt-2" style={{ fontFamily: "'Outfit', sans-serif" }}>{s.title}</h3>
                <p className="text-white/60 text-base leading-relaxed mt-3">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default MethodTimeline;
